import request from "@/utils/request";
import Qs from "qs";

// 品质巡检任务统计
export function patrol(data) {
  return request({
    url: "/statistics/patrol",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 各个园区报事统计
export function maintenance(data) {
  return request({
    url: "/statistics/maintenance",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 各个园区报事类型统计
export function maintenance_type(data) {
  return request({
    url: "/statistics/maintenance_type",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 各个园区报事响应率统计
export function maintenance_response_rate(data) {
  return request({
    url: "/statistics/maintenance_response_rate",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 报事类型响应率统计
export function maintenance_type_response_rate(data) {
  return request({
    url: "/statistics/maintenance_type_response_rate",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 报事类型及时完成率分析
export function maintenance_finish_analysis(data) {
  return request({
    url: "/statistics/maintenance_finish_analysis",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 个人巡检统计
export function patrol_personal(data) {
  return request({
    url: "/statistics/patrol_personal",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 设备巡检任务统计
export function facility(data) {
  return request({
    url: "/statistics/facility",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 电梯巡检任务统计
export function facility_elevator(data) {
  return request({
    url: "/statistics/facility_elevator",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 数据统计导出
export function statisticsExport(data) {
  return request({
    url: "/statistics/export",
    method: "post",
    data: Qs.stringify(data),
    responseType: "blob",
  });
}
